export default "__VITE_ASSET__BtfzXnph__"